module.exports = __webpack_public_path__ + "580fa6f092149bda094fc44d61a13596.jpg";